"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";

import { getSupabaseClient } from "@/lib/supabase/client";

export default function Home() {
  const router = useRouter();

  useEffect(() => {
    const supabase = getSupabaseClient();
    if (!supabase) {
      router.replace("/auth");
      return;
    }

    let hasToken = false;
    try {
      hasToken = document.cookie
        .split(";")
        .some((cookie) => cookie.trim().startsWith("sb-"));
    } catch {
      hasToken = false;
    }

    if (!hasToken) {
      try {
        hasToken = Object.keys(window.localStorage).some((key) =>
          key.startsWith("sb-")
        );
      } catch {
        hasToken = false;
      }
    }

    if (!hasToken) {
      router.replace("/auth");
      return;
    }

    supabase.auth
      .getSession()
      .then(({ data }) => {
        if (data.session) {
          router.replace("/lesson-guide");
          return;
        }

        router.replace("/auth");
      })
      .catch(() => {
        router.replace("/auth");
      });
  }, [router]);

  return <div className="min-h-screen bg-white" />;
}
